/**
 * Feature flags Code 2 Roues.
 *
 * Pour activer/désactiver des pans entiers du produit sans supprimer le code.
 * Mettre à `true` pour réactiver, à `false` pour désactiver.
 *
 * Variables d'environnement (override) :
 *  - REACT_APP_B2B_ENABLED=true  → force l'activation B2B
 *
 * Historique :
 *  - 2026-06 · B2B désactivé : Bruno (créateur Code 2 Roues) a rejoint une
 *    moto-école en tant que salarié, son activité freelance est en pause.
 *    La partie Back-Office B2B (CRM clients, devis, factures, flyers, agenda)
 *    est masquée mais le code est conservé pour réactivation ultérieure.
 */

const envFlag = (key, fallback) => {
  if (typeof process !== 'undefined' && process.env && process.env[key] !== undefined) {
    return process.env[key] === 'true';
  }
  return fallback;
};

export const FEATURES = {
  /**
   * Active la partie B2B (Back-office CRM pour moto-école freelance).
   * Quand `false` :
   *  - `/admin/b2b` redirige vers `/admin/dashboard`
   *  - L'item de menu "Back-office B2B" est masqué dans le sidebar admin
   *  - Le lien "Auto-écoles & moto-écoles" du footer est masqué
   *  - `/pro` et `/prestations-pro` redirigent vers `/`
   */
  B2B_ENABLED: envFlag('REACT_APP_B2B_ENABLED', true),
};

export default FEATURES;
